import React from 'react';
import './Card.css'; // We'll create this for styling

function Card({ card }) {
  if (!card) {
    // This case might be for an uninitialized slot, distinct from an intentionally empty pile
    return <div className="card empty-placeholder"><span>Slot</span></div>; 
  }

  if (card.isEmptyPile) { // New prop for explicitly empty piles
    return (
      <div className="card empty-card pile-placeholder">
        <span>{card.value || 'Empty'}</span>
      </div>
    );
  }

  if (card.isBack) {
    return (
      <div className="card card-back minimalist-back">
        <div className="minimalist-logo-oval">
          <span className="minimalist-logo-text">{card.value || 'UNO'}</span>
        </div>
      </div>
    );
  }

  const cardColor = card.color || 'black'; // Used for background of colored cards, or black for wilds
  let displayValue = card.value;
  let symbolColorClass = 'text-white'; // Default symbol/text color is white for Minimalista faces
  let cardBgClass = cardColor.toLowerCase(); // e.g., 'red', 'blue', 'black' for wild

  // Determine displayValue for action cards (text/simple icons for now)
  if (card.card_type === 'skip') displayValue = '🚫';
  if (card.card_type === 'reverse') displayValue = '⇄';
  if (card.card_type === 'draw_two') displayValue = '+2'; // Placeholder, will be graphic
  
  if (card.card_type === 'wild') {
    cardBgClass = 'black'; // Wilds always have black background
    // symbolColorClass remains 'text-white' for +4, W, or corner icons
    displayValue = 'W'; // Placeholder for main, corner will be W
  } else if (card.card_type === 'wild_draw_four') {
    cardBgClass = 'black';
    displayValue = '+4'; // For corners
  }

  return (
    <div className={`card uno-card minimalist-face ${cardBgClass}`}>
      <span className={`card-value-corner-tl ${symbolColorClass}`}>{displayValue}</span>
      <span className={`card-value-main ${symbolColorClass}`}>{displayValue}</span>
      <span className={`card-value-corner-br ${symbolColorClass}`}>{displayValue}</span>
    </div>
  );
}

export default Card; 